import React, { useState } from 'react';
import Modal from '../common/Modal';
import { moveField } from './constants/handleFieldset';

const MoveFieldModal = ({
  fieldsets,
  fieldToMove,
  viewMoverModal,
  closeMoverModal,
  setFieldsets,
}) => {
  const [selectedFieldset, setSelectedFieldset] = useState(null);
  const fromFieldset = fieldsets.find(
    (fs) => fs.id === fieldToMove.fieldset_id
  );

  const handleMoveField = async () => {
    if (!selectedFieldset.id) return;
    let moved = await moveField(fieldToMove.id, selectedFieldset.id);
    if (moved.ok) {
      closeMoverModal();
      setFieldsets((fieldsets) => {
        let oldFS = fieldsets.find((fs) => fs.id === fromFieldset.id);
        let newFS = fieldsets.find((fs) => fs.id === selectedFieldset.id);
        oldFS.fields = oldFS.fields.filter((f) => f.id !== fieldToMove.id);
        newFS.fields = [...newFS.fields, moved.data.field];
        fieldsets[fieldsets.indexOf(oldFS)] = oldFS;
        fieldsets[fieldsets.indexOf(newFS)] = newFS;
        return fieldsets;
      });
    }
  };

  return (
    <Modal show={viewMoverModal} onClose={closeMoverModal}>
      <header>
        <h3>Relocate This Field</h3>
      </header>

      <div className='available-container-content'>
        <div className='container-list-wrapper'>
          <div className='row'>
            <b>Field to Move:</b> {fieldToMove.name}
          </div>
          <br />
          <h4>Select a destination fieldset:</h4>
          <ol className='container-list'>
            {fieldsets.length > 0 ? (
              fieldsets
                .filter((fs) => fs.id != fromFieldset.id)
                .map((fs) => {
                  return (
                    <li
                      key={`fs-mover-${fs.id}`}
                      className={
                        selectedFieldset?.id === fs.id
                          ? `fieldset-${fs.id} selected`
                          : `fieldset-${fs.id}`
                      }
                      id={`fs-mover-${fs.id}`}
                      onClick={() => setSelectedFieldset(fs)}
                    >
                      {fs.name}
                    </li>
                  );
                })
            ) : (
              <li className='empty'>No fieldsets...</li>
            )}
          </ol>
        </div>

        <div className='flex-controls'>
          <button
            disabled={!selectedFieldset}
            onClick={() => handleMoveField()}
          >
            Move Field
          </button>
          <button onClick={closeMoverModal} className='blue'>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MoveFieldModal;
